import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {AccordionComponent} from "../../accordion/accordion.component";
import {OptInJackpotBetDialogBox} from "./boxes/opt-in-jackpot-bet-dialog/opt-in-jackpot-bet-dialog.box";
import {OptInTextCaptionBox} from "./boxes/content/opt-in-text-caption/opt-in-text-caption.box";
import {OptInTextContentBox} from "./boxes/content/opt-in-text-content/opt-in-text-content.box";
import {OptInTextTitleBox} from "./boxes/content/opt-in-text-title/opt-in-text-title.box";
import {OptInAccordionContentComponent} from "./components/opt-in-accordion-content/opt-in-accordion-content.component";
import {OptInDialogHeaderComponent} from "./components/opt-in-dialog-header/opt-in-dialog-header.component";
import {OptInAccordionTitleComponent} from "./accordion-title/opt-in-accordion-title.component";
import {OptInDialogFooterBox} from "./boxes/footer/opt-in-dialog-footer.box";
import {OptInDialogFooterButtonBox} from "./boxes/footer/opt-in-dialog-footer-button.box";
import {useState} from "react";


export interface IOptInJackpotBetDialogOptions {
    optIn(): void;
    optOut(): void;
}
export const JackpotBetsOptInDialogComponent: React.FC<IOptInJackpotBetDialogOptions> = observer((props) => {
    const services = useServices();
    const [isExpanded, setIsExpanded] = useState(false);

    const handleExpandChange = (expanded: boolean) => {
      setIsExpanded(expanded);
    };

    return (
        <OptInJackpotBetDialogBox>
            <OptInDialogHeaderComponent isExpanded={isExpanded}/>
            <OptInTextTitleBox>
                {services.translation.translate('Ready to try 888jackpot?')}
            </OptInTextTitleBox>
            <OptInTextContentBox>
                {services.translation.translate("You're about to play the 888jackpot game. Select Join the Pot for a chance to win 1 out of 6 jackpots that can drop on any spin.")}
            </OptInTextContentBox>
            <OptInTextCaptionBox >
                {services.translation.translate("For UK, Gibraltar & Jersey customers with online GBP account: Play online slots/table games displaying the V Play icon with main cash balance for random chances to spin V Play Wheel. When notification appears above V Play icon, click to spin wheel & claim prize – both within 7 days of notification. Prizes £0.30–£1000 (varying odds) randomly generated. Multiple games allowed sequentially. Fair play rules & T&Cs apply.")}
            </OptInTextCaptionBox>
            <AccordionComponent
                title={<OptInAccordionTitleComponent />}
                content={<OptInAccordionContentComponent />}
                isTitleCentered={true}
                onExpandChange={(isExpanded: boolean) => {
                    handleExpandChange(isExpanded);
                    services.jackpotBet.sendJackpotBetEvent('opt_in_popup_rules_expand',
                        ``, `expanding:${isExpanded}`);
                }
            }
            />

            <OptInDialogFooterBox>
                <OptInDialogFooterButtonBox
                    preset="primary"
                    fullWidth
                    className={'cy-opt-in-jackpot-bet-button'}
                    onClick={props.optIn}>
                    {services.translation.translate('JOIN_JACKPOT_BET')}
                </OptInDialogFooterButtonBox>
                <OptInDialogFooterButtonBox
                    preset="secondary"
                    fullWidth
                    className={'cy-opt-out-jackpot-bet-button'}
                    onClick={props.optOut}
                >
                    {services.translation.translate('PLAY_WITHOUT_JACKPOT_BET')}
                </OptInDialogFooterButtonBox>
            </OptInDialogFooterBox>
        </OptInJackpotBetDialogBox>
    )
})